import { render, staticRenderFns } from "./ListaCupons.vue?vue&type=template&id=123abda9&scoped=true&"
import script from "./ListaCupons.vue?vue&type=script&lang=js&"
export * from "./ListaCupons.vue?vue&type=script&lang=js&"
import style0 from "./ListaCupons.vue?vue&type=style&index=0&id=123abda9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "123abda9",
  null
  
)

export default component.exports